<template>
  <div
    class="layout-top-panel fixed top-0 z-[101] max-md:!h-auto"
    :class="[
      $route.name === 'ch-id'
        ? '!backdrop-blur-md max-md:!relative max-md:!top-unset max-md:!left-0 max-md:!w-full'
        : '',
    ]"
  >
    <slot></slot>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss">
  .layout-top-panel {
    height: 80px;
    width: 100%;
    box-shadow: 0px 8px 8px -4px rgba(20, 16, 41, 0.03);
  }
</style>
